<div class="container-fluid cw-background">
  <mat-card class="mat-elevation-z8 mt-3 mb-5">
    <mat-card-title class="title-page">Tickets List</mat-card-title>
    <button routerLink="/tickets/create" class="create" mat-fab color="accent">
      <mat-icon>add</mat-icon>
    </button>
    <mat-card-content class="mt-4">
      <div class="container-fluid">
        <app-data-table
          *ngIf="ticketTableConfig"
          [config]="ticketTableConfig"
          (getData)="ticketTableService.getTickets($event)"
        ></app-data-table>
      </div>
    </mat-card-content>
  </mat-card>
</div>
